export const HOME = {
  emergentLink: "home-emergent-link",
};

export const NAV = {
  root: "site-nav",
  logo: "nav-logo",
  linkWork: "nav-link-work",
  linkApproach: "nav-link-approach",
  linkStory: "nav-link-story",
  linkTeam: "nav-link-team",
  linkServices: "nav-link-services",
  cta: "nav-cta-start-project",
};

export const HERO = {
  root: "hero-section",
  headline: "hero-headline",
  copy: "hero-copy",
  ctaPrimary: "hero-cta-primary",
  ctaSecondary: "hero-cta-secondary",
  scrubVideo: "hero-scrub-video",
  scrubHint: "hero-scrub-hint",
};

export const STATS = {
  root: "stats-section",
  audience: "stat-audience",
  stories: "stat-stories",
  adSpend: "stat-ad-spend",
};

export const APPROACH = {
  root: "approach-section",
  toggleGroup: "push-pull-toggle",
  togglePush: "toggle-push",
  togglePull: "toggle-pull",
  visual: "push-pull-visual",
  imgNight: "owl-image-night",
  imgDay: "owl-image-day",
  videoN2D: "transition-night-to-day",
  videoD2N: "transition-day-to-night",
  captionCard: "approach-caption",
};

export const WORK = { root: "work-section" };
export const PROCESS = { root: "process-section" };
export const VOICES = { root: "voices-section" };
export const CONTACT = { root: "contact-section", cta: "contact-cta-book" };
export const FAQ = { root: "faq-section" };
export const FOOTER = { root: "site-footer" };
